import React, { useCallback, useContext, useEffect, useState } from 'react';
// import PlacedholderCard from '../../../components/cards/PlaceholderCard';
import { getForms } from '../../../services/forms/formsService';
import SimpleLoader from '../../../components/Loader/SimpleLoader';
import { UserContext } from '../../../utils/contexts/UserContext';
import { isSSA } from '../../../utils/constants/roles';
import { toastFormError } from '../formUtils';
import Add from './Add';
import FormCard from './FormCard';

// Пагинации в UI нет, а форм немного (по одной на год экзамена) — берём всё.
const PAGE_SIZE = 100;

const useForms = () => {
  const [forms, setForms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchForms = useCallback(() => {
    setIsLoading(true);
    getForms({ page_size: PAGE_SIZE })
      .then((res) => setForms(res?.results ?? []))
      .catch((err) => {
        console.error('Ошибка при получении форм:', err);
        toastFormError(err, 'Не удалось загрузить формы');
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchForms();
  }, [fetchForms]);

  return {
    forms,
    fetchForms,
    isLoading,
  };
};

const Forms = () => {
  const { user } = useContext(UserContext);
  const { forms, fetchForms, isLoading } = useForms();
  // Создать, скопировать и удалить форму может только SSA; TRADMIN видит
  // карточки и открывает редактор.
  const canManage = isSSA(user);
  // Годы, на которые форма уже есть: на них не копируем (одна форма на год).
  const yearsWithForm = new Set(
    forms
      .map((form) => form?.exam_year_year)
      .filter((year) => typeof year === 'number'),
  );

  return (
    <div className='flex flex-col gap-8 rounded-md border bg-white p-6'>
      <h2 className='text-lg font-semibold'>Формы</h2>
      <div className='flex flex-row flex-wrap gap-4'>
        {isLoading ? (
          <SimpleLoader className='h-10' />
        ) : (
          //   <PlacedholderCard />
          <>
            {canManage && <Add />}
            {forms.map((form) => (
              <FormCard
                key={form?.uuid}
                form={form}
                refreshData={fetchForms}
                canManage={canManage}
                nextYearTaken={yearsWithForm.has(form?.exam_year_year + 1)}
              />
            ))}
            {!canManage && !forms.length && (
              <div className='text-slate-500'>Форм пока нет</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Forms;
